import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutTopBottom: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-top-bottom, margin, padding"><path d="M20.25 7.75V16.25L3.75 16.25V7.75L20.25 7.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M21 20.25H3" stroke="currentColor" strokeWidth="1.5"/><path d="M21 3.75H3" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconLayoutTopBottom;
